export default __webpack_public_path__ + "static/media/file-spreedsheets.0a6ddfbc.svg";